import React from "react";
import "./Benefits.css";
import BenefitsHead from "./BenefitsHead";
import BenefitsPara from "./BenefitsPara";

const Benefits = () => {
  return (
    <div className="benefitContainer">
      <BenefitsHead />
      <BenefitsPara />
    </div>
  );
};

export default Benefits;
